<template>
  <div class="container-income-report">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow>
        <template #left>
          <div style="display: flex; align-items: center" @click="goPrevious">
            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
            <span class="tit-left">
              {{ $t('lang.MyBeans.k005') }}
            </span>
          </div>
        </template>
        <template #right>
          <div class="search-select" @click="handleTimePop">
            <span v-if="chooseTime">{{ handleMoment(chooseTime, 'YYYY-MM-DD') }}</span>
            <span v-else>{{ $t('lang.BaseCommon.k034') }}</span>
            <img :class="{ activeTime: showPop }" src="@/assets/packageAssets/common/arrow06.webp" alt="" />
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <div class="myincome-list">
        <div
          class="list-item"
          :class="{ todayIncome: key == $t('lang.MyBeans.k020'), lineBottom: key == $t('lang.MyBeans.k020') || key == $t('lang.BaseCommon.k079') }"
          v-for="key in list.keys()"
          :key="key"
        >
          <span>{{ key }}</span>
          <div class="myincome-beans">
            <i>{{ list.get(key) }}</i>
            <img :src="getMatchImg('beans')" alt="" />
          </div>
        </div>
      </div>
      <div class="title">{{ $t('lang.MyBeans.k019') }}</div>
      <div class="performance-data">
        <div class="perfor-item">
          <span>{{ transformSeconds5(data.onlineDuration) }}</span>
          <span>{{ $t('lang.MyBeans.k011') }}</span>
        </div>
        <div class="perfor-item">
          <span>{{ transformSeconds5(data.videoCallDuration) }}</span>
          <span>{{ $t('lang.BaseCommon.k036') }}</span>
        </div>
        <div class="perfor-item">
          <span>{{ data.repliedUsersCount }}</span>
          <span>{{ $t('lang.MyBeans.k014') }}</span>
        </div>
      </div>

      <table class="table" cellspacing="0" cellpadding="0">
        <tr>
          <td rowspan="5" class="video-call-ms">{{ $t('lang.MyBeans.k021') }}</td>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k012') }}</span>
              <span>{{ data.privateCallSuccessTimes }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k006') }}</span>
              <span>{{ data.videoPassTodayIncomeAmount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k010') }}</span>
              <span>{{ data.missedCallTimes }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k001') }}</span>
              <span>{{ data.answeringRate }}%</span>
            </div>
          </td>
        </tr>
        <!-- <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k004') }}</span>
              <span>{{ data.incomeRate }}%</span>
            </div>
          </td>
        </tr> -->
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k022') }}</span>
              <span>{{ this.transformSeconds4(data.videoCallDuration) }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td rowspan="6" class="video-call-ms">{{ $t('lang.BaseCommon.k078') }}</td>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k015') }}</span>
              <span>{{ msgInfo.sendMsgCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k007') }}</span>
              <span>{{ msgInfo.receivedCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k013') }}</span>
              <span>{{ msgInfo.profitableMessagesCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k003') }}</span>
              <span>{{ msgInfo.chatUsersCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k014') }}</span>
              <span>{{ msgInfo.repliedUsersCount }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="td-con">
              <span>{{ $t('lang.MyBeans.k009') }}</span>
              <span>{{ msgInfo.chatUsersRepliedRate }}%</span>
            </div>
          </td>
        </tr>
      </table>

      <div class="tips">{{ $t('lang.MyBeans.k017') }}</div>
      <div class="tips tips-text">{{ $t('lang.MyBeans.k018') }}</div>
    </div>
    <TimeDay :showPop="showPop" @handleCurrentDate="handleCurrentDate"></TimeDay>
  </div>
</template>

<script>
import CTimeDay from '@/components/CTimeDay'
import { apiFetchReportDetail } from '@/api/imee'
import moment from 'moment'

export default {
  components: {
    TimeDay: CTimeDay,
  },
  props: {},
  data() {
    const query = this.$route.query
    return {
      date: query.date || null,
      showPop: false,
      chooseTime: query.date || new Date(),
      data: {},
      listMap: new Map(),
      msgInfo: {},
      scene: query.scene || null,
    }
  },
  created() {
    this.fetchReportDetail()
  },
  mounted() {},
  methods: {
    toPage(path) {
      this.$router.push({
        path,
      })
    },
    // handleBackPath() {
    //   if (this.scene) {
    //     this.closeWeb()
    //   } else {
    //     this.goPrevious()
    //   }
    // },
    // 打开日期选择
    handleTimePop() {
      this.showPop = true
    },
    // 关闭弹框
    closePop() {
      this.showPop = false
    },
    // 根据时间刷选
    handleCurrentDate(time) {
      this.chooseTime = moment(time).format('yyyy-MM-DD')
      this.fetchReportDetail(this.chooseTime)
    },

    fetchReportDetail(val) {
      const date = this.date || moment(new Date()).format('yyyy-MM-DD')
      apiFetchReportDetail(date).then((res) => {
        if (res) {
          this.data = res
          this.msgInfo = res && res.chatMsgInfo
        }
      })
    },
  },
  watch: {},
  computed: {
    list() {
      this.listMap.set(this.$t('lang.MyBeans.k020'), this.data.todayIncomeAmount)
      this.listMap.set(this.$t('lang.BaseCommon.k080'), this.data.videoCallTodayIncomeAmount)
      this.listMap.set(this.$t('lang.BaseCommon.k077'), this.data.videoPassTodayIncomeAmount)
      this.listMap.set(this.$t('lang.BaseCommon.k063'), this.data.messageTodayIncomeAmount)
      this.listMap.set(this.$t('lang.BaseCommon.k076'), this.data.giftTodayIncomeAmount)
      this.listMap.set(this.$t('lang.BaseCommon.k073'), this.data.bonusTodayIncomeAmount)
      this.listMap.set(this.$t('lang.BaseCommon.k079'), this.data.otherTodayIncomeAmount)
      // this.list.set(this.$t('lang.MyBeans.k011'), this.transformSeconds4(res.onlineDuration)) // 返回的是多少秒 需要处理成xxm xxm xxs
      // this.list.set(this.$t('lang.MyBeans.k023'), res.timesOfVideoCall)
      // this.list.set(this.$t('lang.MyBeans.k022'), this.transformSeconds4(res.videoCallDuration)) //返回的是多少秒 需要处理成xxm xxm xxs
      // this.list.set(this.$t('lang.MyBeans.k002'), res.answeringRate + '%') // 返回的是数字  需要加百分号
      // this.list.set(this.$t('lang.MyBeans.k008'), res.replyMessageUsers) //
      return this.listMap
    },
  },
}
</script>
<style lang="scss" scoped>
.container-income-report {
  width: 100%;
  min-height: 100vh;
  background: #fff;
}

.search-select {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 22px;
  margin-top: 4px;
  background: #f9f9fb;
  border-radius: 6px;
  text-align: center;
  line-height: 22px;
  font-size: 11px;
  font-family: 'Inter-Regular';
  font-weight: 400;
  color: #666666;
  > img {
    width: 10px;
    margin-left: 4px;
  }
  .activeTime {
    transform: rotateX(180deg);
  }
}
.main {
  width: 100%;
  height: 100%;
  padding: 0 24px 30px;
}
.myincome-list {
  width: 100%;
  margin-top: 16px;
  .list-item {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333;
    font-weight: 500;
    font-size: 14px;
    > span {
      display: block;
      white-space: nowrap;
      font-family: 'Inter-Medium';
      line-height: 17px;
    }
    .myincome-beans {
      display: flex;
      align-items: center;
      i {
        display: block;
        margin: 0 4px;
        color: #666666;
      }
      > img {
        width: 14px;
        height: 14px;
      }
    }
  }
  .todayIncome {
    color: #a337fc;
    font-weight: 600;
    font-family: 'Inter-Bold';
    > span {
      font-family: 'Inter-Bold';
    }
    .myincome-beans {
      i {
        color: #a337fc;
      }
    }
  }
  .lineBottom {
    margin-bottom: 20px;
    border-bottom: 1px solid #f7e4ff;
  }
}
.title {
  height: 20px;
  font-family: 'Inter-Regular';
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}
.performance-data {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
  font-family: 'Inter-Regular';
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  .perfor-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    > span:nth-child(1) {
      height: 20px;
      font-weight: 600;
      font-size: 14px;
      color: #a337fc;
      line-height: 20px;
    }
  }
}

.table {
  width: 100%;
  margin-bottom: 20px;
  border: 1px solid #ecc3ff;
  font-family: 'Inter-Regular';
  tr,
  td {
    height: 40px;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    border: 1px solid #f7e4ff;
    background-color: #fefaff;
  }
  .video-call-ms {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    line-height: 17px;
    background-color: #fbf2ff;
  }
  td {
    padding: 0 10px;
    .td-con {
      display: flex;
      justify-content: space-between;
      > span:nth-child(2) {
        color: #333333;
        font-weight: 600;
      }
    }
  }
}

.tips {
  font-family: 'Inter-Regular';
  font-size: 14px;
  color: #666666;
}
.tips-text {
  display: block;
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}

::v-deep .van-nav-bar__title {
  color: #000;
  font-weight: bold;
  font-size: 17px;
  font-family: 'Inter-Regular';
}
</style>
